import React from 'react'
import sty from './ErrorPage.module.css'

const WebCvPrivate = () => {
	return (
		<div className={sty['error__contents-outer']}>
			<div className={sty['error__tit-outer']}>
				<p className={sty['error__contents-txt']}>この経歴書は現在閲覧できません</p>
			</div>
		</div>
	);
}

export default WebCvPrivate
